<p-toast></p-toast>

<div class="card">
    <!-- GO BACK -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
            <button pButton pRipple type="button" label="{{lbl_save}}" class="p-button-raised p-button-success"
                *ngIf="this.purchOrdDtl != null" (click)="saveUpdatePurchOrdDtl()"></button>
        </ng-template>
    </p-toolbar>
    <!-- TAB VIEW -->
    <p-tabView>
        <p-tabPanel header="Ingrese inventario fisico" [selected]="true">
            <!-- MAIN CONTENT -->
            <div class="p-grid">
                <div class="p-col-12 p-lg-12 p-md-12 p-sm-12">
                    <p-panel>
                        <div class="p-grid">
                            <!-- INFO -->
                            <div class="p-lg-6 p-md-6 p-sm-12">
                                <!-- INPUT -->
                                <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                                    <div class="subTitle p-col-12 p-md-4">
                                        <span>Coordinación</span>
                                    </div>
                                    <div class="p-col-12 p-md-8">
                                        <span>000000000 San Pedro de Los Pinos</span>
                                    </div>
                                </div>
                                <!-- INPUT -->
                                <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                                    <div class="subTitle p-col-12 p-md-4">
                                        <span>Fecha de inventario</span>
                                    </div>
                                    <div class="p-col-12 p-md-8">
                                        <span>01/12/2023</span>
                                    </div>
                                </div>
                            </div>
                            <div class="p-lg-6 p-md-6 p-sm-12">

                                <!-- INPUT -->
                                <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                                    <div class="subTitle p-col-12 p-md-4">
                                        <span>Mostrar los articulos</span>
                                    </div>
                                    <div class="p-col-12 p-md-8">
                                        <p-dropdown [options]="multList" optionLabel="value" [showClear]="true"
                                            placeholder="Selecione opcion"></p-dropdown>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-panel>
                </div>
            </div>
            <!-- MAIN TABLE -->
            <p-table [exportFilename]="tableName" *ngIf="purchOrdDtl" #dt [value]="purchOrdDtl" [columns]="[{ field: 'itemId', header: 'Id Articulo' },{ field: 'descri', header: 'Descripcion' },
                        { field: 'conv', header: 'Mult' },{ field: 'consumption', header: 'Participantes Per' },{ field: 'twentyPercent', header: '+20%' },
                        { field: 'subtotal', header: 'Subtotal' },{ field: 'onHand', header: 'Existencia' },
                        { field: 'budget', header: 'Presupuesto' },{ field: 'ordD.appQty', header: 'Requerido' },{ field: 'ordD.unitCost', header: 'Precio' },
                        { field: 'total', header: 'Importe' }]" [rows]="5" [paginator]="true"
                [globalFilterFields]="['itemId','descri','conv','consumption','twentyPercent','subtotal','onHand','budget','ordD.appQty','ordD.unitCost','total']"
                [(selection)]="selectedOrderLst" selectionMode="multiple" [rowHover]="true" dataKey="itemId"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [showCurrentPageReport]="true" responsive="true" editMode="row">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between">
                        <!-- MAIN TITLE-->
                        <h5 class="p-md-6">Control de inventario</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{lbl_search}}..." />
                        </span>
                    </div>

                    <span class="p-input-icon-left">

                        <button pButton pRipple [label]="Delete" icon="pi pi-trash" class="p-button-danger p-mr-2"
                            (click)="deleteselectedPurchOrdDtl()"
                            [disabled]="!selectedOrderLst || !selectedOrderLst.length"></button>

                        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                            class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                            class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                        <button type="button" pButton pRipple icon="pi pi-filter"
                            (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto  p-mr-2"
                            pTooltip="Selection Only" tooltipPosition="bottom"></button>

                        <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-mr-2 z-5"
                            (click)="reloadData()"></button>

                        <button type="button" pButton pRipple icon="pi pi-plus" (click)="create()"
                            class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                    </span>

                </ng-template>


                <ng-template pTemplate="header">
                    <!-- Order -->
                    <tr>
                        <th pSortableColumn="itemId">Id Articulo <p-sortIcon field="itemId"></p-sortIcon></th>
                        <th pSortableColumn="descri">Descripción<p-sortIcon field="descri"></p-sortIcon></th>
                        <th pSortableColumn="conv">Mult <p-sortIcon field="conv"></p-sortIcon></th>
                        <th pSortableColumn="consumption">Participantes Per <p-sortIcon
                                field="consumption"></p-sortIcon>
                        </th>
                        <th pSortableColumn="twentyPercent">+20% <p-sortIcon field="twentyPercent"></p-sortIcon></th>
                        <th pSortableColumn="subtotal">Subtotal <p-sortIcon field="subtotal"></p-sortIcon></th>
                        <th pSortableColumn="ordD.appQty">Existencia <p-sortIcon field="ordD.appQty"></p-sortIcon></th>
                        <th pSortableColumn="budget">Presupuesto <p-sortIcon field="budget"></p-sortIcon></th>
                        <th pSortableColumn="onHand">Requerido <p-sortIcon field="onHand"></p-sortIcon></th>
                        <th pSortableColumn="costoUnit">Precio <p-sortIcon field="costoUnit"></p-sortIcon></th>
                        <th pSortableColumn="total">Importe <p-sortIcon field="total"></p-sortIcon></th>
                        <th></th>
                    </tr>
                    <!-- Filter -->
                    <tr>
                        <th>
                            <p-columnFilter type="text" field="itemId"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter type="text" field="descri"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter type="text" field="conv"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter type="text" field="consumption"></p-columnFilter>
                        </th>

                        <th>
                            <p-columnFilter type="text" field="twentyPercent"></p-columnFilter>
                        </th>

                        <th>
                            <p-columnFilter type="text" field="subtotal"></p-columnFilter>
                        </th>

                        <th>
                            <p-columnFilter type="text" field="onHand"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter type="text" field="budget"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter type="text" field="ordD.appQty"></p-columnFilter>
                        </th>
                        <th>
                            <p-columnFilter type="text" field="ordD.unitCost"></p-columnFilter>
                        </th>

                        <th>
                            <p-columnFilter type="text" field="total"></p-columnFilter>
                        </th>
                        <th> </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-order let-editing="editing" let-ri="rowIndex">
                    <tr *ngIf="order?.itemId == null">
                        <td class="itemCat2" colspan="12">
                            {{ order?.descri ? order.descri : 'S/N' }}
                        </td>
                    </tr>

                    <tr *ngIf="order?.itemId != null" [pSelectableRow]="order" [pEditableRow]="order">

                        <td> {{ order?.itemId ?order.itemId : '0' }}</td>
                        <td style="white-space: normal; word-wrap: break-word;">
                            <mark
                                [ngStyle]="{ 'background-color': order?.itemColor != null ? order?.itemColor : 'transparent' }">
                                {{ order?.descri ? order.descri : 'S/N' }}
                            </mark>
                        </td>
                        <td> {{ order?.conv ? '$' + order.conv : '0' }}</td>
                        <td> {{ order?.consumption ? '$' + order.consumption : '0' }}</td>
                        <td> {{ order?.twentyPercent ? '$' + order.twentyPercent : '0' }}</td>
                        <td> {{ order?.subtotal ? '$' + order.subtotal : '0' }}</td>
                        <td> {{ order?.onHand ? order.onHand : '0' }}</td>
                        <td>${{order.budget |number:.00}}</td>

                        <td *ngIf="order?.ordD != null || order?.ordD?.appQty != null">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" [(ngModel)]="order.ordD.appQty">
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ order?.ordD?.appQty ? '$' + order.ordD.appQty : '0' }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td *ngIf="order?.ordD == null || order?.ordD?.appQty == null"> {{ order?.ordD?.appQty ? '$' +
                            order.ordD.appQty : '0' }}</td>

                        <td *ngIf="order?.ordD != null || order?.ordD?.unitCost != null">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" [(ngModel)]="order.ordD.unitCost">
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ order?.ordD?.unitCost ? '$' + order.ordD.unitCost : '0' }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td *ngIf="order?.ordD == null || order?.ordD?.unitCost == null"> {{ order?.ordD?.unitCost ? '$'
                            +
                            order.ordD.unitCost : '0' }}</td>

                        <td>{{ order?.total ? '$' + order.total : '0' }}</td>

                        <td style="text-align:center">
                            <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                (click)="onRowEditInit(order)" class="p-button-rounded p-button-text"></button>
                            <button *ngIf="editing && order?.ordD?.unitCost != null && order?.ordD?.appQty != null"
                                pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                (click)="saveUpdatePurchOrd(order)"
                                class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                (click)="onRowEditCancel(order, ri)"
                                class="p-button-rounded p-button-text p-button-danger"></button>
                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                                (click)="deletepurchOrdDtl(order)"></button>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        En total existen {{purchOrdDtl != null ? purchOrdDtl.length : 0 }} entradas.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </p-tabView>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>